import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["link", "template"]

  connect() {
    // Verifica al cargar si hay un formulario de certificación y ajusta la visibilidad del botón de "Agregar Certificación" acorde.
    this.adjustAddButtonVisibility();
  }

  remove_association(event) {
    event.preventDefault();

    let certificationElement = event.currentTarget.closest("[data-form='certification']");
    let destroyField = certificationElement.querySelector(".destroy-field");

    if (destroyField) {
      destroyField.value = '1';
    }
    certificationElement.style.display = 'none';

    this.adjustAddButtonVisibility();
  }

  add_association(event) {
    event.preventDefault();

    // Verifica si ya hay un formulario de certificación
    if (this.hasExistingForm()) {
      return;
    }

    let content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.linkTarget.insertAdjacentHTML('beforebegin', content)
    flatpickr(".datepicker", {});

    // Ajusta la visibilidad del botón de "Agregar Certificación" después de agregar una certificación
    this.adjustAddButtonVisibility();
  }

  hasExistingForm() {
    // Revisa si hay un formulario de certificación visible
    let existingForm = this.element.querySelector("[data-form='certification']:not([style*='display: none'])");
    return existingForm !== null;
  }


  adjustAddButtonVisibility() {
    let addButton = document.querySelector('[data-action="click->nested-form#add_association"]');
    if (this.hasExistingForm()) {
      addButton.style.display = 'none';
    } else {
      addButton.style.display = 'block';
    }
  }
}
